import { render, staticRenderFns } from "./LoanInstallments.vue?vue&type=template&id=56a79572"
import script from "./LoanInstallments.vue?vue&type=script&lang=js"
export * from "./LoanInstallments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports